// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"49":"460b71d8","567":"58c79147"}[chunkId] + ".css";
};